import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FormHelperText, IconButton, InputLabel, Tooltip } from "@mui/material";
import {ClearOutlined, Upload  } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';

import {renderTextEllipsis} from "../../utils/Helpers";
import messages from "../../assets/locale/messages";
import Button from "../Button";

import "./fileUpload.scss";

const FileUpload = ({
    id,
    name,
    label,
    required,
    placeholder,
    fileName,
    fileValue,
    onChange,
    errMsg,
    acceptedFormatlabel,
    acceptedFormathint,
    labelClassName,
    acceptFilesFormat,
    touched,
    previewUrl,
}) => {
    const lang = useSelector((state) => state.locale.lang);
    const { inputsValidations } = messages[lang];

    const handleDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        onChange(files[0]);
    };
    
    const handleDragOver = (e) => e.preventDefault();

    const handleViewFile = () => {
        if (fileValue) {
            //create a url for the file
          const fileURL = URL.createObjectURL(fileValue);
          const newTab = window.open(); // Open the tab immediately
          if (newTab) {
            newTab.location.href = fileURL; // Then assign the file URL
          } else {
            alert("Popup blocked. Please allow popups.");
          }
        }else if(previewUrl){
            //open the preview url in a new tab
            window.open(previewUrl);
        }
    };

    return(
        <div 
          className="file-upload"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
            <input 
             type="file"  
             id={id} 
             name={name} 
             className="d-none" 
             onChange={(e)=>onChange(e.target.files[0])} 
             accept={acceptFilesFormat} 
             value=""/>
            <div className="d-flex gap-1 mb-2">
            <InputLabel htmlFor={id || name} className={labelClassName}>
                <>
                   {renderTextEllipsis(label,80)}
                    {required ? <span className="err-asterisk"> *</span> : ""}
                </>
            </InputLabel>
            {!!acceptedFormatlabel && 
                <Tooltip title={<span className="fsize-12">{acceptedFormathint} </span>}>
                    <span className="text-bg-primary-mid fsize-14 font-reguler ms-2">
                        {acceptedFormatlabel}
                    </span>
                </Tooltip>
            }
            </div>
            <div className={`${!!errMsg && touched ? 'err-border' : 'input-padding'} bg-gray-mid d-flex gap-1 justify-content-between input-style align-items-center`}>
                <Tooltip
                    title={<span className="fsize-12">{!!fileName ? fileName : placeholder}</span>}
                >
                    {!!fileName 
                        ?<div className="file-name-container">
                                <div className="file-name">{fileName}</div>
                            </div>
                        : <span className="file-placeholder placeholder">{placeholder}</span>
                    }
                </Tooltip>
                <div className="d-flex align-items-center gap-1">
                    {!!fileName && 
                        <IconButton
                            onClick={()=>onChange(null)}
                            size="small"
                        >
                                <ClearOutlined fontSize="small"/>
                        </IconButton>
                    }
                    {(!!fileValue || !!previewUrl)  && 
                        <Button 
                            type="button"
                            className={"gray text-white py-2"}
                            label={<VisibilityIcon />}
                            onClick={handleViewFile}
                        />
                    }
                    <Button 
                        type="button"
                        className={"gray text-white py-2"}
                        label={<Upload />}
                        onClick={() => document.getElementById(id).click()}
                    />
                    </div>
            </div>
            <FormHelperText
                error={true}
                className={`font-medium fsize-12 ${lang === "ar" && "text-end"}`}
              >
                {!!errMsg && touched ? inputsValidations[errMsg] : ""}
              </FormHelperText>
        </div>
    );
};

FileUpload.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    fileValue: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    errMsg: PropTypes.string.isRequired,
    acceptedFormatlabel: PropTypes.string.isRequired,
    acceptedFormathint: PropTypes.string.isRequired,
    labelClassName: PropTypes.string.isRequired,
    acceptFilesFormat: PropTypes.string.isRequired,
    touched: PropTypes.bool.isRequired,
    previewUrl: PropTypes.string,
};

export default FileUpload;